import React from 'react';
import { useHistory } from 'react-router-dom';
import ListItem from '../../../../components/lists/list-item/list-item';
import { DataVariant, ListItemData } from '../../../../components/lists/list-item/types';
import { formatDate } from '../../../../helpers/date-formatters';
import { formatNumber } from '../../../../helpers/number-formatters';
import { SecurityTransferListItem as ListItemDataInput } from '../../../../logic/graphql/types/types.d';
import { Paths } from '../../../../navigation/paths';
import { useIntl } from 'react-intl';

const SecurityTransferListItem = (props: {
  listItem: ListItemDataInput;
  style?: React.CSSProperties | undefined;
  mobileHeight?: number;
}): JSX.Element => {
  const history = useHistory();
  const intl = useIntl();
  const handleOnClick = (): void => {
    history.push(Paths.security_transfers + '/' + props.listItem.transaction_code);
  };

  const data: ListItemData = {
    status: props.listItem.status,
    iconVisible: true,
    title: props.listItem.security.name,
    transactionCode: props.listItem.transaction_code,
    detailBlocks: [
      {
        dataLines: [
          {
            label: intl.formatMessage({ id: 'securityTransfers.listItem.fromAccount' }),
            value: props.listItem.account,
          },
        ],
      },
      {
        dataLines: [
          {
            label: intl.formatMessage({ id: 'securityTransfers.listItem.count' }),
            value: formatNumber(
              props.listItem.amount,
              intl.formatMessage({ id: 'securityTransfers.listItem.pcs' }),
            ),
            variant: DataVariant.highlighted,
          },
        ],
      },
    ],
    date: formatDate(props.listItem.order_date),
  };

  return (
    <ListItem
      onClick={handleOnClick}
      data={data}
      style={props.style}
      mobileHeight={props.mobileHeight}
    />
  );
};

export default SecurityTransferListItem;
